import React, {useState} from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import {LifecycleAction} from "../../../../../../gd/const/lifecycle";
import {FieldEditableMode} from "../../../../../proto/render/editable";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";
import {ToggleSize} from "../../components/toggle-statefull";
import FieldToggle_Component from "../../components/toggle-stateless";
import TasksViewManager from "../../../../../../gd-modules/tasks-view/core/manager"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"


export default function FieldToggle_TableCell(props:FieldTableCellProps):React.ReactElement {

    const canEdit = !props.manager.isReadOnly && props.field.canEdit(props.listItem.item)

    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (!canEdit) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const value = props.field.getViewValue(props.listItem.item)

    const toggleValue = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!canEdit) return

        onChange(!value)
    }

    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        props.listItem.task.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.task.save()
        props.listItem.updateLastUpdateTime() // otherwise it wont re-render
        FieldProto_updateView(props.manager as TasksViewManager, props.field)
    }

    const classes = Classes("ui5-field-editable w-100-percent h-100-percent size-small", props.className, {
        'is-hovered' : mode === FieldEditableMode.HOVERED
    })

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>

            <div className={classes} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <FieldToggle_Component size    = {ToggleSize.SIZE_16}
                                       value   = {value}
                                       onClick = {toggleValue}/>
            </div>

        </div>
    )
}
